import { env } from './env';

const base = env.VITE_BRAND_ASSETS_BASE_URL?.replace(/\/$/, '') ?? null;

export const brandAssets = base
  ? {
      logo: `${base}/logo.png`,
      trophy: `${base}/trophy.png`,
      loadingBg: `${base}/loading-bg.jpg`,
      brandingLogo: `${base}/branding.png`,
      lobbyCardBg: `${base}/lobby-card-bg.png`,
    }
  : null;

export type BrandAssets = NonNullable<typeof brandAssets>;
